import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3402';

export interface Escalation {
  id: string;
  ticketId: string;
  reportId?: string;
  reason: string;
  priority: 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';
  status: 'PENDING' | 'ASSIGNED' | 'IN_PROGRESS' | 'RESOLVED' | 'CLOSED';
  assignedTo?: string;
  escalatedBy: string;
  resolution?: string;
  resolvedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  assignedUser?: {
    id: string;
    username: string;
    displayName: string;
  };
}

export interface CreateEscalationData {
  ticketId: string;
  reportId?: string;
  reason: string;
  priority: 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';
}

export interface AssignEscalationData {
  assignedTo: string;
}

export interface ResolveEscalationData {
  resolution: string;
}

const escalationService = {
  // Create escalation
  create: async (data: CreateEscalationData): Promise<Escalation> => {
    const response = await axios.post(`${API_URL}/api/admin/escalations`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Get all escalations
  getAll: async (params?: {
    status?: string;
    priority?: string;
    assignedTo?: string;
  }): Promise<Escalation[]> => {
    const response = await axios.get(`${API_URL}/api/admin/escalations`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Get single escalation
  getById: async (id: string): Promise<Escalation> => {
    const response = await axios.get(`${API_URL}/api/admin/escalations/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  },

  // Assign escalation
  assign: async (id: string, data: AssignEscalationData): Promise<Escalation> => {
    const response = await axios.patch(
      `${API_URL}/api/admin/escalations/${id}/assign`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return response.data;
  },

  // Start work on escalation
  startWork: async (id: string): Promise<Escalation> => {
    const response = await axios.patch(
      `${API_URL}/api/admin/escalations/${id}/start`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return response.data;
  },

  // Resolve escalation
  resolve: async (id: string, data: ResolveEscalationData): Promise<Escalation> => {
    const response = await axios.patch(
      `${API_URL}/api/admin/escalations/${id}/resolve`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return response.data;
  },

  // Close escalation
  close: async (id: string): Promise<Escalation> => {
    const response = await axios.patch(
      `${API_URL}/api/admin/escalations/${id}/close`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return response.data;
  },
};

export default escalationService;
